// extracted by mini-css-extract-plugin
export default {"component":"styles__component--WpNPu","count":"styles__count--fa6hE","gradient":"styles__gradient--Ah3zg"};